import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-branding-unavailable',
  templateUrl: './branding-unavailable.html',
  styleUrl: './branding-unavailable.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandingUnavailable {
  readonly title = inject(Title).setTitle('Ha ocurrido un error');

  reload(): void {
    window.location.reload();
  }
}
